import groupBy from 'lodash.groupby';
import pickBy from 'lodash.pickby';

export default function objectRemoveMinAttribute (obj, attrKey) {
  const attrValArray = Object.keys(obj).map(key => [key, obj[key][attrKey]]);
  const valAttrMap = groupBy(attrValArray, i => i[1]);

  const orderedValuesWithoutMinSet = new Set(
    Object.keys(valAttrMap).sort().
      slice(1, Object.keys(valAttrMap).length)
  );
  return pickBy(obj, value => orderedValuesWithoutMinSet.has(value[attrKey]));
}
